import { useNavigate } from 'react-router-dom';
import LoadingButtonGeneral from '../../../../../components/general/buttons/loadingButtonGeneral';
import { FINAL_CAUSALITY_EDIT } from '../../../../../../routes/paths';
import EditIcon from '@mui/icons-material/Edit';
import { FinalCausalityDetailActionsProps } from './props';

export const FinalCausalityDetailActions = ({
    finalCausalityId,
}: FinalCausalityDetailActionsProps) => {
    const navigate = useNavigate();
    const textBtnStyle = {
        display: {
            xs: 'none',
            lg: 'block',
        },
    };

    const btnIconStyle = { marginRight: { xs: -1, lg: undefined } };

    return (
        <>
            <LoadingButtonGeneral
                variant="outlined"
                title="Editar"
                sx={{ mr: 1 }}
                onClick={() =>
                    navigate(`${FINAL_CAUSALITY_EDIT}/${finalCausalityId}`)
                }
                startIcon={<EditIcon sx={btnIconStyle} />}
                textSx={textBtnStyle}
            />
        </>
    );
};
